<template>
    <div class="flex-column gap-small">

        <div id="google-sign-in" v-show="!isAuthenticated"></div>

        <p id="account-information" v-if="isAuthenticated">
            <span class="bold">Email:</span> {{ email }} <br>
            <span class="bold">Subscription:</span> {{ subscriptionStatus }}
        </p>

        <button class="full-width blue-hover-button" alt="subscription button" @click="onManageSubscription"
            v-if="isSubscriptionActive">
            Manage Subscription
        </button>
        <button class="full-width blue-hover-button" alt="subscription button" @click="onClickSub"
            v-if="!isSubscriptionActive">
            InfiniteX Plus
        </button>
        <button id="account-sign-out" class="full-width" alt="sign out button" @click="onSignOut"
            v-if="isAuthenticated">
            Sign Out
        </button>
    </div>
</template>

<style lang="scss" scoped>
@use "../../../../theme";

#account-information {
    @include theme.exo-font(theme.$paper-white, 0.8rem, 400);
}

.full-width {
    width: 100%;
}

.flex-column {
    display: flex;
    flex-direction: column;
}

.bold {
    font-weight: 700;
}

.gap-small {
    gap: 0.25em;
}

@mixin button-background($colour-hover) {
    box-sizing: border-box;
    padding-block: 0.8em;
    background-color: theme.$paper-white;
    padding-inline: 1em;
    @include theme.exo-font(theme.$super-dark-blue, 0.8rem, 700);
    border: none;
    outline: 0;
    border-radius: 0.2em;
    transition: all 250ms;
    @include theme.clickable();

    &:hover {
        background-color: $colour-hover;
        @include theme.exo-font(theme.$paper-white, 0.8rem, 700);
    }
}

.blue-hover-button {
    @include button-background(theme.$sky-blue);
}

#account-sign-out {
    @include button-background(theme.$alert-red);
}
</style>

<script lang="js">
import { defineComponent } from "vue"
import { useToast } from "vue-toastification"
import { AuthApi } from "../../../api/AuthApi"
import { SET_JWT_TOKEN } from "../../../store/AppStoreMutations"

export default defineComponent({
    setup: function () {
        return {
            toast: useToast()
        }
    },
    data: function () {
        return {
            subscriptionManageUrl: null,
            titleButtonManageSubscription: "Manage Subscription",
            subscriptionStatus: "Loading..."
        }
    },
    computed: {
        email: function () {
            return this.$store.getters.getEmail
        },
        isAuthenticated: function () {
            return this.$store.getters.getIsAuthenticated
        },
        isSubscriptionActive: function () {
            return this.$store.getters.getIsSubscriptionActive
        }
    },
    methods: {
        onManageSubscription: function () {
            if (this.subscriptionManageUrl == null) {
                console.warn("Subscription URL not yet available")
                return
            }

            window.open(this.subscriptionManageUrl, "_blank")
        },
        onClickSub: function () {
            this.$router.push("/plus")
            this.$emit("onClose")
        },
        onSignOut: function () {
            google.accounts.id.disableAutoSelect()
            this.$store.commit(SET_JWT_TOKEN, "")
            this.$emit("onClose")
        },
        authGoogle: async function (data) {
            try {
                const token = await AuthApi.postGoogleAuth(data.credential)
                this.$store.commit(SET_JWT_TOKEN, token)

                AuthApi.getSubscriptionInfo(token).then((info) => {
                    this.subscriptionStatus = info.status
                    this.subscriptionManageUrl = info.url
                })
            } catch (e) {
                console.error(e)
            }
        }
    },
    mounted: function () {

        if (this.$store.getters.getIsAuthenticated) {
            AuthApi.getSubscriptionInfo(this.$store.getters.getJwtToken).then((info) => {
                this.subscriptionStatus = info.status
                this.subscriptionManageUrl = info.url
            })
        }


        google.accounts.id.initialize({
            client_id: "867555017270-5g2bqsutrr2gs2813uldei217q6rme5f.apps.googleusercontent.com",
            callback: this.authGoogle
        })

        google.accounts.id.renderButton(
            document.getElementById("google-sign-in"),
            { theme: "outline", size: "large", text: "continue_with", width: 320 }
        )

    },
    emits: ["onClose"]
})
</script>
